export default __webpack_public_path__ + "static/media/logo_light_background.f5cf1c44.png";